module.exports = __webpack_public_path__ + "static/media/ic_general_close.cb1d774a.svg";